import axios, { AxiosHeaders, AxiosRequestConfig, AxiosResponse } from 'axios';
import { redirectToLogin } from './redirectMethods';

const requestConfig = {
  headers: {
    'FFF-Auth': 'V1.1',
  },
  withCredentials: true,
};

axios.interceptors.request.use(
  (config: AxiosRequestConfig) => ({
    ...config,
    headers: {
      ...config.headers,
      ...requestConfig.headers,
    } as unknown as AxiosHeaders,
    withCredentials: requestConfig.withCredentials,
  }),
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (_) => _,
  (error) => {
    if (error.response && error.response.status === 401) {
      redirectToLogin();
    } else {
      throw error;
    }
  },
);

const rConfig = (baseURL: string) => ({ baseURL });

const get = async (baseURL: string, url: string): Promise<AxiosResponse> =>
  axios.get<AxiosResponse>(url, rConfig(baseURL)).then((response) => response);

const getWithCustomHeaders = async (
  baseURL: string,
  url: string,
  customHeaders: unknown,
): Promise<AxiosResponse> =>
  axios
    .get<AxiosResponse>(baseURL + url, { headers: { ...customHeaders } })
    .then((response) => response);

const post = async (baseURL: string, data: unknown, url: string): Promise<AxiosResponse> =>
  axios.post<AxiosResponse>(url, data, rConfig(baseURL)).then((response) => response);

const put = async (baseURL: string, data: unknown, url: string): Promise<AxiosResponse> =>
  axios.put<AxiosResponse>(url, data, rConfig(baseURL)).then((response) => response);

export { get, post, put, getWithCustomHeaders };
